import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNavBuygatherLogo = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 100,
	height: 40,
	fill: "none",
	viewBox: "0 0 100 40",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "black",
			d: "M9.04738 20.0791C9.9792 20.6714 10.5885 21.6408 10.5885 22.9153C10.5885 25.1412 8.77859 26.5952 6.53865 26.5952H1.27029V14.0296H6.18025C8.36644 14.0296 10.1405 15.4477 10.1405 17.6198C10.1405 18.6609 9.72833 19.4867 9.04738 20.0791ZM6.18025 16.7223H4.13742V18.9482H6.18025C6.82536 18.9482 7.27335 18.4814 7.27335 17.8352C7.27335 17.189 6.84328 16.7223 6.18025 16.7223ZM6.53865 23.9026C7.25543 23.9026 7.72134 23.3999 7.72134 22.6999C7.72134 21.9998 7.25543 21.4972 6.53865 21.4972H4.13742V23.9026H6.53865Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "black",
			d: "M16.6762 26.8465C13.9166 26.8465 11.8379 25.2309 11.8379 22.5383V14.0296H14.7051V22.287C14.7051 23.2384 15.1531 24.0462 16.6762 24.0462C18.1994 24.0462 18.6474 23.2384 18.6474 22.287V14.0296H21.5145V22.5383C21.5145 25.2309 19.4358 26.8465 16.6762 26.8465Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "black",
			d: "M33.6214 14.0296L29.4103 21.7664V26.5952H26.5432V21.7664L22.3321 14.0296H25.5934L27.9767 18.8763L30.36 14.0296H33.6214Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "black",
			d: "M46.2203 19.5944V20.6714C46.2203 24.5129 43.5502 26.8465 40.038 26.8465C36.0957 26.8465 33.2644 23.9385 33.2644 20.3304C33.2644 16.6864 36.1495 13.7783 39.8409 13.7783C42.2421 13.7783 44.267 14.9631 45.3243 16.6504L42.8872 18.0506C42.3676 17.2249 41.2386 16.5786 39.823 16.5786C37.7085 16.5786 36.1315 18.1404 36.1315 20.3483C36.1315 22.4845 37.6368 24.0462 40.0739 24.0462C41.7404 24.0462 42.8335 23.3102 43.2815 22.1075H39.9305V19.5944H46.2203Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "black",
			d: "M55.3559 26.5952L54.7287 24.6206H50.0696L49.4424 26.5952H46.3065L50.5714 14.0296H54.2269L58.4918 26.5952H55.3559ZM50.9297 21.928H53.8686L52.3991 17.3146L50.9297 21.928Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "black",
			d: "M67.0911 14.0296V16.7941H63.8656V26.5952H60.9984V16.7941H57.7729V14.0296H67.0911Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "black",
			d: "M75.1556 14.0296H78.0227V26.5952H75.1556V21.6049H71.2133V26.5952H68.3462V14.0296H71.2133V18.8404H75.1556V14.0296Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "black",
			d: "M83.043 23.8308H88.0605V26.5952H80.1759V14.0296H87.9709V16.7941H83.043V18.8763H87.5229V21.6049H83.043V23.8308Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "black",
			d: "M96.2725 26.5952L93.9072 22.4665H92.5453V26.5952H89.6781V14.0296H94.6956C97.0789 14.0296 98.9963 15.9504 98.9963 18.3378C98.9963 19.8816 98.0645 21.2818 96.6847 21.9818L99.3547 26.5952H96.2725ZM92.5453 16.7223V19.9534H94.6956C95.4841 19.9534 96.1292 19.2533 96.1292 18.3378C96.1292 17.4223 95.4841 16.7223 94.6956 16.7223H92.5453Z"
		})
	]
});
const ForwardRef = forwardRef(SvgNavBuygatherLogo);
export default ForwardRef;
